import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {setSqftSlabToolVisited, addRoomWithVisitedSlabTool, showSlabTool} from "../../../../../actions/sqftSlabFunctions";
import {
  setSQFTActiveButton,
  setSQFTMenuOpened
} from "../../../../../actions/sqftMenuFunctions";
import {enableRegularMode, enableSlabMode} from "../../canvas/store/canvasHelper";
import {clearAllMenusEvents} from "../../canvas/core/workspace/workspaceEvents";
import {getQtCatName} from "../../../helpers/sqftQuotesHelper";

const SlabToolSwitcher = (props) => {
  const {isShowSlabTool, isSlabToolVisited, showSlabTool, setSQFTActiveButton, setSQFTMenuOpened,
    setSqftSlabToolVisited, addRoomWithVisitedSlabTool} = props;

  const handleButtonClick = () => {
    clearAllMenusEvents();
    !isShowSlabTool ? enableSlabMode(true) : enableRegularMode(); // before change isShowSlabTool we need to disable and restore shapes
    !isSlabToolVisited && setSqftSlabToolVisited(true);
    addRoomWithVisitedSlabTool(getQtCatName());
    showSlabTool(!isShowSlabTool);
    setSQFTActiveButton("");
    setSQFTMenuOpened("");
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label ui-radio-label--blue ui-radio-label--small">
        <FormattedMessage id="sqft.navigation.menu.slabMode"/>
      </span>
      <button className={"ui-radio ui-radio--small" + (isShowSlabTool ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => ({
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
  isSlabToolVisited: store.sqftSlabState.isSlabToolVisited,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  switcherPosition: store.sqftManualCalculationState.switcherPosition,
});

const mapDispatchToProps = {
  showSlabTool,
  setSQFTActiveButton,
  setSQFTMenuOpened,
  setSqftSlabToolVisited,
  addRoomWithVisitedSlabTool,
};

export default connect(mapStateToProps, mapDispatchToProps)(SlabToolSwitcher);
